<template>
  <modal
    :content="content"
    :show-upgrade-button="showButton"
    :title="title"
    :open="true"
    @close="$emit('close')"
  >
    <p v-html="content"></p>

    <center v-if="showButton">
      <a class="btn" @click="upgrade()"><span v-t>Upgrade now</span> &rarr;</a><br />
    </center>
  </modal>
</template>

<script>
import Modal from '@/components/Modal.vue'

export default {
  components: {
    Modal,
  },
  props: {
    content: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    showButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    upgrade() {
      this.$emit('close')
      this.$router.push({ name: 'billing' }).catch((err) => {})
    },
  },
}
</script>
